import api from 'data/axios/react-query-api';
import { type FeatureFlags } from 'data/types/entities/feature-flags.entity';

export const fetchFeatureFlags = async (): Promise<Record<string, boolean>> => api.get('/features');

export const fetchFeatureFlagsConfig = async (): Promise<FeatureFlags> => api.get('/features/config');

export const updateFeatureFlagsConfig = async (data: FeatureFlags): Promise<void> => api.put('/features/config', data);
